import { AxiosRequestConfig } from "axios";

import { createApiQueryHook, IPaginateable, mapPagination } from "../../utils/api";
import { serialize } from "../../utils/url";
import { ILocationList } from "../types";

export type ILocationListQueryParameters = IPaginateable;

export type ILocationListQueryResult = ILocationList;

export function locationListQuery({ pagination }: ILocationListQueryParameters): AxiosRequestConfig {
    return {
        method: "GET",
        url: `/locations${serialize(
            {
                ...mapPagination(pagination),
            },
            true,
        )}`,
    };
}

export const useLocationListQuery = createApiQueryHook<ILocationListQueryParameters, ILocationListQueryResult>(
    locationListQuery,
);
